import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import Paper from '@eig-builder/core-ui/Paper'

import { useIsMobile } from '@eig-builder/core-utils/hooks/useResponsiveQuery'

import AffiliateInfo from './affiliate-info'
import BottomRowButtons from './bottom-row-buttons'
import BottomRowInfo from './bottom-row-info'
import BottomRowMenu from './bottom-row-menu'
import ContactInfo from './contact-info'
import NpsInfo from './nps-info'
import PartnerInfo from './partner-info'
import SdnMessage from './sdn-message'
import VerticalInfo from './vertical-info'

import AccountDetailsContextWrapper from './context'

const StyledPaper = styled(Paper)`
  margin-bottom: ${props => props.theme.spacing(6)}px;
`

const Content = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
`

const TextCenter = styled.div`
  text-align: center;
`

const RightSideWrapper = styled.div`
  align-self: center;
  text-align: right;
  min-width: 242px;
`

const Row = styled.div`
  margin-top: ${props => props.theme.spacing(4)}px;
`

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
 
  ${({ isMobile }) => isMobile && 'flex-direction: column;'}
`

const AccountDetails = props => {
  const {
    account,
    restoreAccount,
    handleFraudDialog,
    synchronizeCards,
    goodwillCredits
  } = props

  const isMobile = useIsMobile()

  return (
    <AccountDetailsContextWrapper>
      <SdnMessage account={account} />
      <StyledPaper>
        <Content>
          <div className='row'>
            <div className='col-6 col-xl-9'>
              <ContactInfo account={account} />
            </div>
            <TextCenter className='col-auto ml-auto'>
              <PartnerInfo account={account} />
              <VerticalInfo account={account} />
            </TextCenter>
          </div>
          <NpsInfo account={account} />
          <AffiliateInfo account={account} />
          <BottomWrapper isMobile={isMobile}>
            <Row className='row'>
              <BottomRowInfo account={account} goodwillCredits={goodwillCredits} />
            </Row>
            <RightSideWrapper>
              <BottomRowButtons account={account} />
              <BottomRowMenu
                account={account}
                restoreAccount={restoreAccount}
                handleFraudDialog={handleFraudDialog}
                synchronizeCards={synchronizeCards}
              />
            </RightSideWrapper>
          </BottomWrapper>
        </Content>
      </StyledPaper>
    </AccountDetailsContextWrapper>
  )
}

AccountDetails.propTypes = {
  account: PropTypes.object,
  synchronizeCards: PropTypes.func.isRequired,
  restoreAccount: PropTypes.func.isRequired,
  handleFraudDialog: PropTypes.func,
  goodwillCredits: PropTypes.number
}

export default AccountDetails
